import * as React from 'react';

import { IDienstleistung, IVorgang, IObjekt } from '../../models/ApiTypes';
import { Panel, ListGroup, ListGroupItem, Glyphicon } from 'react-bootstrap';
import { inject } from '../../utils/decorators';
import { UiStore } from '../../stores/UiStore';


interface IVorgangListeProps {
  dienstleistung: IDienstleistung;
  vorgaenge: IVorgang[];
}

export default class VorgangListe extends React.Component<IVorgangListeProps, {}> {
  render() {
    const { dienstleistung, vorgaenge } = this.props;
    const vorgaengeZuDienstleistung = vorgaenge.filter(vorgang => vorgang.kuerzel_dienstleistung === dienstleistung.kuerzel_dienstleistung);
    return (
    <Panel header={`${dienstleistung.sortierung}. ${dienstleistung.kuerzel_dienstleistung}`}>
      <ListGroup fill={true}>
        {vorgaengeZuDienstleistung.map((vorgang, index) => <VorgangListItem key={index} vorgang={vorgang} />)}
      </ListGroup>
    </Panel>
    );
  }
}


interface IVorgangListItemProps {
  vorgang: IVorgang;
}

class VorgangListItem extends React.Component<IVorgangListItemProps, {}> {

  @inject(UiStore) uiStore: UiStore;

  render() {
    const { vorgang } = this.props;
    const header = (
      <span>
        {vorgang.sortierung}. {vorgang.name} {vorgang.korrekturvorgang && (
        <span>
          (<Glyphicon glyph="pencil" /> Korrektur)
        </span>
      )}
      </span>
    );

    let statusClass = undefined;
    if (vorgang.vgstatus) {
      statusClass = 'vorgang-' + vorgang.vgstatus.toLowerCase();
    }
    let objekt: IObjekt | undefined = undefined;
    if (vorgang.objekte && vorgang.objekte.length > 0) {
      objekt = vorgang.objekte[0];
    }
    return (
      <ListGroupItem
        onClick={() => this.uiStore.navigateTo(`vorgang/${vorgang.vorgangguid}`)}
        header={header}
      >
        {objekt && <span>Objekt im Vorgang: {objekt.objektid} (S/N: {objekt.sernr})<br/></span>}
        <span className={statusClass}>{vorgang.statustext}</span>
      </ListGroupItem>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorgaenge/VorgangListe.tsx